import React, {useEffect, useState} from "react";
import {Typography, Modal, FormControl, InputLabel, OutlinedInput} from '@mui/material';
import { useForm, Controller  } from "react-hook-form";

import ButtonMain from "../button/Button_main";
import './Modal_style.scss'

const ModalRejectCommentView = (props) => {
   
    useEffect(()=>{
        console.log('reasonPreview', props)
    },[props])

    const cancel = () => {
        props.setOpenRejectViewModal()
    }

    return(
            <Modal
                open={props.openRejectViewModal}
               // onClose={()=>props.setOpenJobView(false)}
                aria-labelledby="modal-modal-title"
            >   
                <div className="modal-container modal-view">
                    <>  
                        <Typography id="modal-modal-title" variant="textheader3" className="mb-2-modal" component="div">
                            Rejected Reason
                        </Typography>
                        <Typography id="modal-modal-title"  className="" variant="textBaseLight" component="div">
                            Applicant Name : <span className="modal-text-primary">{ props.rejectData.name ? props.rejectData.name : '-'}</span> 
                            { props.rejectData.rate ? (
                            <>                       
                                <span className="px-2-modal">|</span> 
                                Match : <span className="modal-text-primary">{props.rejectData.rate ? props.rejectData.rate : '-'}</span> 
                            </>
                        ):''}
                        </Typography>
                        <div className="border-bottom-modal mb-5-modal"></div>
                        <Typography component={'div'} variant="textBase">
                            {props.rejectData.reason} 
                        </Typography>
                        <div className="modal-footer-right mt-5-modal pt-5-modal border-top-modal">
                            <ButtonMain 
                                variant='primaryOutline' 
                                type='button' 
                                disabled={false} 
                                name='Cancel'
                                class='modal-capitalize'
                                onClick={cancel}
                            />
                        </div>
                    </>
                </div>
                
            </Modal>
    )
}

export default ModalRejectCommentView;